import { useState } from 'react';
import type { Stock } from '../../../types/stock';

const MAX_STOCKS = 5;

interface UseStockMultiSelectionParams {
  stocks: Stock[];
  initialStocks?: Stock[];
}

export function useStockMultiSelection({ stocks, initialStocks }: UseStockMultiSelectionParams) {
  const [selectedStocksMap, setSelectedStocksMap] = useState<Map<number, Stock>>(() => {
    if (initialStocks && initialStocks.length > 0) {
      return new Map(initialStocks.map((s) => [s.id, s]));
    }
    return new Map();
  });
  const [limitError, setLimitError] = useState<string | null>(null);

  const handleToggleStockSelection = (id: number) => {
    const item = stocks.find((x) => x.id === id);
    if (!item) {
      return;
    }

    if (!selectedStocksMap.has(id) && selectedStocksMap.size >= MAX_STOCKS) {
      setLimitError(`Ви можете вибрати максимум ${MAX_STOCKS} складів`);
      return;
    }

    setLimitError(null);
    setSelectedStocksMap((prev) => {
      const newMap = new Map(prev);
      if (newMap.has(id)) {
        newMap.delete(id);
      } else {
        newMap.set(id, item);
      }
      return newMap;
    });
  };

  const handleClearLimitError = () => {
    setLimitError(null);
  };

  return {
    data: {
      selectedStocksMap,
      limitError,
    },
    actions: {
      handleToggleStockSelection,
      handleClearLimitError,
    },
  };
}
